type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const HaierCostingStatus = Object.freeze({
  WAITING_CONFIRM: 1 as const,
  TO_VERIFY: 2 as const,
  APPROVED: 3 as const,
  REJECT: 4 as const,
  EDIT: 5 as const,
  CANCEL: 6 as const,
});

export type HaierCostingStatus = EnumLiteralsOf<typeof HaierCostingStatus>;
